import "./App.css";
import Body from "./components/Body/Body";
import Header from "./components/Header/Header";
import 'bootstrap/dist/css/bootstrap.min.css';

function App() {



  return (
    <div className="App">
      
      {/* <Header /> */}
      <Body/>
    </div>
  );
}

export default App;
